import React, { Component, PropTypes } from 'react';

class LoginForm extends Component {

  constructor(props) {
    super(props);
    // this.state = { userValue: props.loginuser, surnameValue: props.surname, rememberMe: false };
    this.state = { userValue: '', surnameValue: '', rememberMe: false };
    this.handleChangeUser = this.handleChangeUser.bind(this);
    this.handleChangeSurname = this.handleChangeSurname.bind(this);
    this.handleChangeRememberMe = this.handleChangeRememberMe.bind(this);
    this.openDeepLink = this.openDeepLink.bind(this);
  }
  handleChangeUser(event) {
    if (/^[0-9]*$/gm.test(event.target.value) && event.target.value.length < 12) {
      this.setState({ userValue: event.target.value });
    } 
  }
  handleChangeSurname(event) {
    if (/^[ A-Za-z\u00C0-\u017F]*$/gm.test(event.target.value) && event.target.value.length < 101) {
      this.setState({ surnameValue: event.target.value });
    }
  }
  handleChangeRememberMe(event) {
    this.setState({ rememberMe: event.target.checked });
  }
  openDeepLink() {
      const loadedAt = +new Date();
      if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
        setTimeout(() => {
          if ((+new Date() - loadedAt) < 2000) {
            window.location = 'https://itunes.apple.com/it/app/tinaba/id1063359568?mt=8';
          }
        }, 100);
        window.open('https://dl.tinaba.com/index.html?id=' + this.progetto.idProgetto, "_self");
      } else if (/Android/i.test(navigator.userAgent)) {
        setTimeout(() => {
          if ((+new Date() - loadedAt) < 2000) {
            window.location = 'https://play.google.com/store/apps/details?id=it.tinaba.app&hl=it';
          }
        }, 100);
        window.open('it.tinaba.app://?id=' + this.progetto.idProgetto, "_self");
      } else {
        window.open('https://www.tinaba.com/it/', "_self");
      }
  }
  render() {
    let errorBox = '';
    if (this.props.isFailure) {
      errorBox = <div className="error">Errore</div>;
    }
    return (
      <main className="app-body">
        <h2>Inserisci le credenziali richieste per poter effettuare la donazione</h2>
        {errorBox}
        <label htmlFor="tel">Numero di Telefono</label>
        <input
          id="tel"
          type="text"
          value={this.state.userValue}
          onChange={this.handleChangeUser}
          maxLength="11"
        />
        <br />
        <label htmlFor="surname">Cognome Utente</label>
        <input
          id="surname"
          type="text"
          value={this.state.surnameValue}
          onChange={this.handleChangeSurname}
          maxLength="100"
        />
        <br />
        <div className="info-box">
          <a className="info-button">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
              <title>info</title>
              <g>
                <path d="M8,1.24a6.76,6.76,0,0,1,4.78,11.54A6.76,6.76,0,0,1,3.22,3.22,6.71,6.71,0,0,1,8,1.24H8M8,0H8a8,8,0,1,0,8,8A8,8,0,0,0,8,0H8Z" transform="translate(0 0)" fill="#ff4200"/>
                <path d="M7.42,3.26A0.71,0.71,0,0,1,7.94,3a0.73,0.73,0,0,1,.73.73h0a0.72,0.72,0,0,1-.21.52,0.7,0.7,0,0,1-.52.22A0.74,0.74,0,0,1,7.2,3.78,0.71,0.71,0,0,1,7.42,3.26Z" transform="translate(0 0)" fill="#ff4200"/>
                <path d="M9.6,12H6.4V11.9A1.13,1.13,0,0,0,7,11.8a0.56,0.56,0,0,0,.18-0.31,3.1,3.1,0,0,0,0-.83V8.09a13.42,13.42,0,0,0,0-1.4,0.59,0.59,0,0,0-.13-0.32A0.4,0.4,0,0,0,6.8,6.28a1.41,1.41,0,0,0-.48.11l-0.1-.31,2-.87H8.39v5.45a2,2,0,0,0,.16.83,0.77,0.77,0,0,0,.33.31,1.51,1.51,0,0,0,.71.1V12h0Z" transform="translate(0 0)" fill="#ff4200"/>
              </g>
            </svg>
          </a>
          <section>
            <p>Le credenziali sono richieste solo la prima volta che si effettua un Tinabalike da un dispositivo non associato.</p>
            <p>Per poter effettuare il Tinabalike senza associare il dispositivo in modo «permanente» basterà non cliccare il pulsante «ricordami»</p>
          </section>
        </div>
        <div className="clearfix">
          <div className="radio-button">
            <input
              type="checkbox"
              id="rememberme"
              checked={this.state.rememberMe}
              onChange={this.handleChangeRememberMe}
            />
            <label htmlFor="rememberme">Ricordami</label>
          </div>
          <button onClick={(e) => { e.preventDefault(); this.props.onChangeClick(this.state.userValue, this.state.surnameValue, this.state.rememberMe); }}> Login </button>
        </div>
        <div className="clearfix">
          Non sei ancora un utente Tinaba?
          <button className="light" onClick={this.openDeepLink}> Scarica l&apos;app </button>
        </div>
      </main>
    );
  }
}

LoginForm.propTypes = {
  onChangeClick: PropTypes.func.isRequired,
  surname: PropTypes.string,
  loginuser: PropTypes.string,
  isFailure: PropTypes.bool.isRequired
};

export default LoginForm;



/** WEBPACK FOOTER **
 ** ./src/components/LoginForm.jsx
 **/